import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

// Your web app's Firebase configuration
// IMPORTANT: Replace with your actual Firebase project config
const firebaseConfig = {
  apiKey: "AIzaSyCU_c9MO2QNQMztGuoqwyONP6ABYq5JkLg",
  authDomain: "volungo-ea0dc.firebaseapp.com",
  projectId: "volungo-ea0dc",
  storageBucket: "volungo-ea0dc.firebasestorage.app",
  messagingSenderId: "50267364296",
  appId: "1:50267364296:web:5b7665cf10be9f1a2ebefd"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);
